<template>
  <div class="container py-2">
    <div class="container text-center">
      <h3 class="tNormal mb-5">خلاصه سفارش</h3>
      <order-item
        v-for="(item, i) in my_order.product"
        :key="i"
        :theItem="item"
      ></order-item>

      <div class="mt-3">
        <p class="little-title">نام کاربر</p>
        <p class="tLighter">
          {{ my_order.user_name ? my_order.user_name : "" }}
        </p>
        <p class="little-title">توضیحات سفارش</p>
        <p class="tLighter">{{ my_order.desc }}</p>
        <p class="unknown py-1" v-if="my_order.unknown">
          این سفارش باید به صورت ناشناس ارسال گردد
        </p>
        <p class="little-title">آدرس سفارش</p>
        <p class="tLighter">{{ my_order.user_address }}</p>
        <p class="little-title">شماره تماس</p>
        <p class="tLighter">{{ my_order.user_phone }}</p>
        <p class="little-title" v-if="my_order.user_lat">لینک آدرس :</p>
        <a
          v-if="my_order.user_lat"
          :href="
            'https://www.google.com/maps/search/?api=1&query=' +
            my_order.user_lat +
            ',' +
            my_order.user_long
          "
          >‍‍‍‍<button>لوکیشن</button></a
        >
        <p v-if="my_order.delivery_day" class="little-title">زمان تحویل :</p>
        <div>روز</div>
        <div v-if="my_order.delivery_day" class="tLighter mb-2">
          {{ jalali_date }}
        </div>
        <div>ساعت</div>
        <div>
          <span>{{my_order.delivery_time_from}}</span> تا 
          <span>{{my_order.delivery_time_to}}</span>
        </div>
        <p class="little-title" v-if="my_order.receiver_name">
          فرد تحویل گیرنده :
        </p>
        <p v-if="my_order.receiver_name" class="tLighter">
          {{ my_order.receiver_name }}
        </p>
        <p class="little-title" v-if="my_order.receiver_name">
          شماره تلفن تحویل گیرنده :
        </p>
        <p v-if="my_order.receiver_name" class="tLighter">
          {{ my_order.receiver_mobile }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { computed, onMounted, ref } from "@vue/composition-api";
import OrderItem from "./OrderItem.vue";
import Service from "../../../../utils/admin-service";
import jalalim from "jalali-moment";

export default {
  props: ["my_order"],
  components: {
    OrderItem,
  },
  computed:{
    jalali_date(){
      return jalalim(this.my_order.delivery_day).locale("fa").format("YYYY/MM/DD");
    }
  },
  setup(props, context) {
    const items = ref(null);
    const times = ref(null);
    const authService = computed(() => {
      return Service(true);
    });
    const errorHandler = (e) => {};

    onMounted(() => {
      // ///////////
      if (my_order.value.delivery_day != "") {
        authService.value.receive(
          "admin/preorder/time",
          {},
          (s, d) => {
            times.value = d.data;
            my_order.value.delivery_day = jalalim(items.value.delivery_day)
              .locale("fa")
              .format("YY-MM-DD");
            times.value.map((t) => {
              if (t.id == parseInt(my_order.value.delivery_time)) {
                my_order.value.delivery_time =
                  " از ساعت " + t.from + " تا " + t.to;
              }
            });
          },
          errorHandler
        );
      }
    });
    return { my_order };
  },
};
</script>

<style scoped>
.summary {
  background-color: #fff;
  font-size: 0.9rem;
  font-weight: lighter;
}

table {
  border-collapse: separate;
  border-spacing: 0px;
  width: 100%;
  table-layout: auto;
}

td {
  border: 1px solid rgba(127, 127, 127, 0.2);
  white-space: nowrap;
  padding-right: 1rem;
  text-align: center;
}

th {
  text-align: center;
  padding: 1rem;
}

tr {
  width: 100%;
}

.big-cell {
  width: 75%;
  padding: 0.5rem 1rem 0.5rem 1rem;
}

.small-cell {
  width: 25%;
  padding: 0.5rem 1rem 0.5rem 1rem;
}

.accounts {
  border-top: 1px solid rgba(127, 127, 127, 0.2);
}
.unknown {
  background: #ff93bb;
  border-radius: 5px;
}
.little-title {
  color: rgb(45, 45, 122);
  font-weight: bold;
}
</style>